import { useEffect } from 'react';
import { getRealTracker } from '@/utils/realTracker';
import { apiUrl } from '@/utils/api';

interface TrackingPixelProps {
  page?: string;
}

const TrackingPixel = ({ page }: TrackingPixelProps) => {
  useEffect(() => {
    const tracker = getRealTracker();
    if (tracker) {
      const sessionId = tracker.getSessionId();
      
      // Load tracking pixel
      const img = new Image();
      img.src = apiUrl(`/api/tracking/pixel.gif?session=${sessionId}&page=${page || window.location.pathname}&t=${Date.now()}`);
      img.style.display = 'none';
      
      // Add to DOM briefly then remove
      document.body.appendChild(img);
      setTimeout(() => {
        if (document.body.contains(img)) {
          document.body.removeChild(img);
        }
      }, 100);
    }
  }, [page]);

  return null; // This component renders nothing visible
};

export default TrackingPixel;
